import _ from 'lodash';

function BaseCtrl($timeout, $rootScope, $location, $scope, $state, $stateParams, $interval, $window, $ngConfirm, toastr, AppSettings, AuthService, AnalysisService, BioService, PlanService, PlayerService, CommonService, players, menus, AppContextService, UserService, PermissionService) {
  'ngInject';

  const vm = this;

  $rootScope.AppSettings = AppSettings;
  vm.appContext = AppContextService.context;

  if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    vm.appContext.isLocalhost = true;
  }

  vm.appContext.isMobile = window.mobilecheck();
  if (location.protocol === 'file:') {
    vm.appContext.isMobileApp = true;
  }
  vm.appContext.isIOS = !!navigator.userAgent.match(/iphone/gi) || !!navigator.userAgent.match(/ipad/gi);
  vm.appContext.isIpad = !!navigator.userAgent.match(/ipad/gi);
  if (vm.appContext.isIpad) {  // 아이패드인 경우 모바일로 처리
    vm.appContext.isMobile = true;
  }

  if (AuthService.getUser()) {
    vm.appContext.user = AuthService.getUser();
    //var userType = _.find(AppSettings.userTypes, { userTypeId: vm.appContext.user.user_type_id })
    //vm.appContext.role = userType.userType;
    var userType2 = PermissionService.getUserType(vm.appContext.user.user_type_id);
    vm.appContext.role2 = userType2;
    vm.appContext.info = AuthService.getInfo();

    // 감독-선수 소속팀 관련 수정
    var userType3 = PermissionService.getUserType2(vm.appContext.user.user_type_id);
    vm.appContext.role3 = userType3;

    PermissionService.getMainMenu(vm.appContext.user.login_id, vm.appContext.user.uuid);
  }


  vm.appContext.goToMenu = PermissionService.goToMenu;
  vm.appContext.permissionCheck = PermissionService.permissionCheck;
  vm.appContext.menuAccess = PermissionService.menuAccess;

  var showAdminMenu = false;
  vm.appContext.menus = menus;
  console.log('menus', menus);
  _.forEach(menus, function(menu) {
    if (menu.url.match('service/admin') && menu.is_active) {
      showAdminMenu = true;
    }
  });

  if (showAdminMenu) {
    vm.appContext.showAdminMenu = true;
  }

  // 접속 가능한 메뉴인지 확인
  vm.appContext.checkMenuAccess = function(id) {
    return true;
    
    // 전체관리 메뉴 외의 메뉴는 testuser 가 아닌 경우는 권한 관리를 하지 않음
    if (id >= 24 && !vm.appContext.user.login_id.match('testuser')) {
      return true;
    }

    var obj = _.find(vm.appContext.menus, {
      id: id
    });

    if (obj) {
      return obj.is_active;
    } else {
      return false;
    }
  };

  if (players) {
    var players = _.map(players.data.players).map(function (x) {
      return _.assign(x, {
        user_id: Number(x.user_id)
      });
    });


    if ((!$stateParams.team_id || $stateParams.team_id == '0') && !$stateParams.fan_user_team_id) {
      vm.appContext.players.all = [];
    } else {
      vm.appContext.players.all = players;
    }

    if (vm.appContext.role2 === 'player') {
      var data = {
        user_id: vm.appContext.user.user_id,
        login_id: vm.appContext.user.login_id,
        name: vm.appContext.info.name,
        ename: vm.appContext.info.ename,
        team_id: vm.appContext.info.team_id,
      }

      // console.log('data', data)
      vm.appContext.players.all.push(data);

      // console.log('vm.appContext.role2 >>>>', vm.appContext.role2)
      // console.log('vm.appContext.user >>>>', vm.appContext.user)
      // console.log('vm.appContext.info >>>>', vm.appContext.info)
      // console.log('vm.appContext.players >>>>>> ', vm.appContext.players)

    }


  }

  // 결제에 따른 메뉴 접근 권한
  vm.appContext.userMenuAccessMenus = ['스카우팅', '이적', '발탁', '상대팀분석', '상대선수분석', '웨어러블', '메디컬체크', '경기기록', '경기분석', '선수분석'];
  vm.appContext.userMenuAccess = {};
  _.forEach(vm.appContext.userMenuAccessMenus, function(menuName) {
    vm.appContext.menuAccess(null, vm, menuName).then(function(res) {
      vm.appContext.userMenuAccess[menuName] = res;
      console.log(menuName, res);
    }).catch(function(err) {
      console.log(err);
    });
  });

  vm.logout = function() {
    window.localStorage.clear();    // 자동 로그인 관련 정보를 지움
    $state.go('Intro');

    if (!vm.appContext.isIOS) {
      $timeout(function() {
        location.reload();
      }, 500);
    }
  };


}

export default {
  name: 'BaseCtrl',
  fn: BaseCtrl
};